import { render, staticRenderFns } from "./TripAddOnListItem.vue?vue&type=template&id=4f8f73c0&scoped=true&"
import script from "./TripAddOnListItem.vue?vue&type=script&lang=js&"
export * from "./TripAddOnListItem.vue?vue&type=script&lang=js&"
import style0 from "./TripAddOnListItem.vue?vue&type=style&index=0&id=4f8f73c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f73c0",
  null
  
)

export default component.exports